var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 85,
    viewBox: "0 0 31 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 78.45C14.59 73.21 21.07 74.06 14.18 78.84L9 78.45Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 83.34C26.04 76.84 29.28 79.76 22.72 83.75L17.5 83.34Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.82 26.81C27.35 21.74 23.3 18.28 13.52 15.68L13.57 16.38C13.18 16.25 12.79 16.15 12.4 16.05H12.17L11.84 15.97C10.3762 15.5462 8.83988 15.4338 7.33 15.64C6.90267 15.6808 6.48053 15.7646 6.07 15.89C1.42 17 -0.730004 26.44 1.3 34.69C1.74 36.49 3 36.23 4.49 36C4.28144 36.9733 3.9452 37.9148 3.49 38.8C0.899996 44 1.18 49.28 4.7 53.88L9 78.45C9.28 80.32 14.08 80.03 14.18 78.84C14.25 78.08 14.63 72.27 15.1 65.59L17.5 83.34C18.2179 83.9458 19.1076 84.3111 20.044 84.3847C20.9805 84.4582 21.9164 84.2362 22.72 83.75C22.72 83.75 27 57.46 27.5 52.55C28.11 46.24 26.5 44.55 25.36 41.08C26.11 41.48 26.8 41.86 27.36 42.2C30.89 44.4 31.46 35.87 28.82 26.81Z",
    fill: "#252525",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54 23.9C3.29 28.21 6.09 33 4.49 36",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.09 66L13.66 55.19C12.4586 54.827 11.384 54.1324 10.5597 53.186C9.73532 52.2396 9.19473 51.0799 9 49.84",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.74 29.42C24.43 33.64 23.25 35.42 24.53 38.84L25.36 41.08",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.11 12.15C10.11 12.15 10.11 15.02 10.11 17.15C10.11 21.15 18.11 21.33 18.11 17.08V16.18C18.11 16.18 23.92 14.49 21.16 5.94C20.11 2.68 19.32 4.35 17 4.86C14.68 5.37 10.28 6.55 10.11 12.15Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.32L17.17 8.49C17.17 8.49 15.66 8.07 13.34 9.49C11.02 10.91 13.34 13.43 11.59 12.7C9.84 11.97 8.51 10.62 9.83 5.3C11.46 -1.25 22.73 -1 22 6.15L21 6.32Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.07 7.06C17.69 11.67 20.07 15.39 22.59 15.68C22.59 15.68 14.26 20.44 9.49999 15.39C4.92999 10.53 8.15999 4.24 10.69 2.46C17 -2 20.07 7.06 20.07 7.06Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/Teacher.e452ae2fc65f4e0473203aef68b0e978.svg";
export { ForwardRef as ReactComponent };